import { render, staticRenderFns } from "./RicercaField.vue?vue&type=template&id=2c1099b6&scoped=true&"
import script from "./RicercaField.vue?vue&type=script&lang=js&"
export * from "./RicercaField.vue?vue&type=script&lang=js&"
import style0 from "./RicercaField.vue?vue&type=style&index=0&id=2c1099b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1099b6",
  null
  
)

export default component.exports